import React from 'react'
import { useCookies } from 'react-cookie'
import { COOKIE_CONSENT } from '@constants/cookies'
import { Button } from '@shared/components/button'
import Link from 'next/link'
import styled from 'styled-components'

const NotificationContainer = styled.div(({ theme }) => ({
	position: 'fixed',
	backgroundColor: '#fff',
	left: 0,
	maxWidth: 1160,
	right: 0,
	display: 'flex',
	alignItems: 'center',
	margin: '0 16px',
	bottom: 72,
	justifyContent: 'space-between',
	gap: 16,
	padding: '16px',
	borderRadius: 8,
	width: `calc(100% - 32px)`,
	zIndex: 1000,
	boxShadow: theme.shadows.cardShadow,
	flexDirection: 'column',

	a: {
		color: theme.colors.main,
	},

	...theme.typography.text12_16,

	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text14_20,
		bottom: theme.spacingsDesktop.s,
		gap: 24,
		margin: '0 auto',
		flexDirection: 'row',
	},
}))

const ButtonWrapper = styled(Button)(({ theme }) => ({
	height: 40,
	padding: '6px 24px',
	width: '100%',

	...theme.typography.text18_24,

	[theme.mediaQueries.mediaMinWidthMobile]: {
		width: 'unset',
	},
}))

export const CookieWarning = () => {
	const [cookies, setCookie] = useCookies([COOKIE_CONSENT])

	const acceptCookies = () => {
		const oneYearFromNow = new Date()
		oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)
		setCookie(COOKIE_CONSENT, 'true', { path: '/', expires: oneYearFromNow })
	}

	if (cookies[COOKIE_CONSENT]) {
		return null
	}

	return (
		<NotificationContainer>
			<div>
				ООО «Кредит.Клаб»{' '}
				<Link
					target='_blank'
					rel='noreferrer noopener nofollow'
					href='https://public.credit.club/docs/kk/policy/user-data.pdf'
				>
					обрабатывает данные и файлы cookies
				</Link>
				, с целью персонализации сервисов и повышения удобства пользования веб-сайтом. Если вы не
				хотите использования файлов cookies, измените настройки браузера. Пожалуйста, ознакомьтесь{' '}
				<Link
					target='_blank'
					rel='noreferrer noopener nofollow'
					href='https://public.credit.club/docs/kk/policy/cookies.pdf'
				>
					с политикой использования cookies
				</Link>
				.
			</div>
			<ButtonWrapper size='s' type='button' onClick={acceptCookies}>
				Принять
			</ButtonWrapper>
		</NotificationContainer>
	)
}
